<script setup>
import { Link } from "@inertiajs/vue3";
</script>

<template>
    <div class="max-w-md w-full rounded-2xl bg-white lg:p-2 flex flex-col items-center shadow-lg">
        <Link href="/" class="py-8">
            <img :src="$page.props.currentTenant.logo_path" alt="logo" class="h-16 mx-auto" />
        </Link>

        <div class="px-6 pb-6 lg:px-8 lg:pb-8 w-full">
            <slot />
        </div>
    </div>
</template>
